import openSDPWithRoute from '../utils/openSDPWithRoute.js';

export const insertTestDriveCTA = (API, config) => {
	const { testDriveCtaLabel, showTestDriveCta, refreshDsAfterSdpClose } = config;	

	if (showTestDriveCta) {
		API.insertCallToActionOnce('button', 'test-drive', _ => {
			return {
				type: 'default',
				target: '_blank',
				text: {
					en_US: testDriveCtaLabel,
				},
				classes: 'btn btn-block btn-default',
				onclick: () => { 
					openSDPWithRoute('testDrive', refreshDsAfterSdpClose);
				}
			}
		});
	}
};
